import React from 'react';
import styles from './Login.module.css';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import RePackOne from '../../assets/Logo/RePack_logo_text_transparent.png';
import LoginForm from './LoginForm.jsx';
import { Alert } from '@material-ui/lab';

export default function Login() {
  const { reason } = useParams();
  const { t } = useTranslation();

  return (
    <div className={styles.loginPage}>
      <div className={styles.loginCard}>
        <div className={styles.loginHeader}>
          <img src={RePackOne} alt="" className={styles.repackLoginImage} />
          <p className={styles.BCv}>
            <span className={styles.BCLabel}>Battery Cloud</span>
          </p>
        </div>
        <LoginForm />
        <p className={styles.issuesText}>
          {t('havingIssues')}
          <a className={styles.issuesHref} href="/help">
            {t('clickHere')}
          </a>
          {t('toReachOut')}
        </p>
        <a className={styles.resetPasswordHref} href="/resetpassword">
          Reset password
        </a>
      </div>
      {reason === 'tokenExpired' && (
        <Alert className={styles.sessionExpiredAlert} severity={'info'}>
          {t('tokenExpired')}
        </Alert>
      )}
    </div>
  );
}
